import {
	SalesEntityModel,
	ISalesEntityModel,
	IInstitution,
	Institution,
	Association,
	IAssociation,
	SalesRep,
	ISalesRep,
	Chain,
	IChain,
	CompPlan,
	SalesEntityModelList,
	ISalesEntityModelList,
	SalesEntityAddress,
	SalesEntityContact,
	IMerchantsCount,
	Contract,
	ContractResult,
	SalesEntityBoardingHierarchyNew,
	ISalesEntityBoardingHierarchyNew,
	SalesEntityBoardingHierarchy,
	Channel,
	AlliancePartnerESP,
	CompPlanInstanceInq,
	CompPlanListInq,
	CompPlanTier,
	RelationshipType,
	RelationshipTypeEnforced
} from '../../../shared/models/EvoSalesPortalModel';

import {
	BoardTargetsList,
	IBoardTargets,
	SalesEntityBoardTargets,
	ISalesEntityBoardTargets,
	EnhApplicationAgentsResponse
} from '../../../shared/models/boardModels';

import {
	SalesEntityListInquiry,
	SalesEntityView,
	ISalesEntityView,
	SystemModel,
	ISystemModel
} from '../../../shared/models/EvoSalesPortalModel';
import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, from } from 'rxjs';
import { CacheService } from '../../../shared/services/cache.service';
import { Router } from '@angular/router';
import { KeyValuePair } from 'app/shared/classes/key-value-pair';
import { RelationshipTypeEnforcedDTO } from 'app/shared/models/RelationshipTypeEnforced';
import { map } from 'rxjs/operators';
import { E_PriceLists } from 'app/shared/models/EcommissionsModels';
export namespace SalesEntityConstants {
	export const DEFAULT_ID = 0;
}

@Injectable()
export class SalesEntityService {
	controller = 'api/salesentity/';
	public boardTargets: Array<IBoardTargets>;
	private _isEditMode: boolean;
	public isEditMode: Observable<boolean>;
	private isEditModeSubject: BehaviorSubject<boolean>;

	public set editMode(newValue: boolean) {
		this._isEditMode = newValue;
		//console.log("Edit Mode Set to: ",newValue);
		this.isEditModeSubject.next(newValue);
	}

	constructor(
		private http: HttpClient,
		private cookieSvc: CookieService,
		private cacheService: CacheService,
		private router: Router
	) {
		// this.PopulateSalesEntityBoardTargets();
		this.isEditModeSubject = new BehaviorSubject<boolean>(false);
		this.isEditMode = this.isEditModeSubject.asObservable();
		this.editMode = false;
	}

	public pingTest() {
		return this.http.get(this.controller + 'ping');
	}

	public getSalesEntities(
		inquiry?: SalesEntityListInquiry
	): Observable<SalesEntityModelList> {
		if (!inquiry.MaxRows) {
			inquiry.MaxRows = 2147483647;
		}
		const objectObservable = this.getSalesEntitiesRequest(inquiry);

		const result = from(
			objectObservable
		).pipe(map((src: ISalesEntityModelList, index: number) => {
			const dst = new SalesEntityModelList(src);
			src.SalesEntities.forEach((element, i, arr) => {
				const stronglyTyped = new SalesEntityModel(element);
				dst.SalesEntities.splice(i, 1, stronglyTyped);
			});
			return dst;
		}));
		return result;
	}

	public getSalesEntitiesForSelect(
		sepid: number
	): Observable<SalesEntityModelList> {

		const objectObservable = this.getSalesEntitiesForSelectRequest(sepid);

		const result = from(
			objectObservable
		).pipe(map((src: ISalesEntityModelList, index: number) => {
			const dst = new SalesEntityModelList(src);
			src.SalesEntities.forEach((element, i, arr) => {
				const stronglyTyped = new SalesEntityModel(element);
				dst.SalesEntities.splice(i, 1, stronglyTyped);
			});
			return dst;
		}));
		return result;
	}

	public getSalesEntity(entityID?: number): Observable<SalesEntityView> {
		const url = this.controller + 'GetSalesEntity/?entityID=' + entityID;
		const objectObservable = this.cacheService.get(
			url,
			this.http.get<ISalesEntityView>(url)
		);

		const result = from(objectObservable).pipe(map(
			(ob: ISalesEntityView) => {
				const stronglyTyped = new SalesEntityView(ob);
				return stronglyTyped;
			}
		));
		return result;
	}

	private getSalesEntitiesRequest(inquiry?: SalesEntityListInquiry) {
		const url = this.controller + 'GetSalesEntities';
		const body = this.cacheService.stringify(inquiry);

		return this.cacheService.get(
			url + body,
			this.http.post(url, body, {
				headers: new HttpHeaders().set(
					'Content-Type',
					'application/json'
				)
			})
		);
	}

	private getSalesEntitiesForSelectRequest(sepid: number) {
		const url = this.controller + 'GetSalesEntitiesForSelect/?salesEntityParentID=' + sepid.toString();
		const body = sepid.toString();
		return this.cacheService.get(url, this.http.get<ISalesEntityModelList>(url));

	}

	public getSystems(): Observable<Array<SystemModel>> {
		const url = this.controller + 'GetSystems';
		return this.cacheService.get(
			url,
			this.http.get<Array<ISystemModel>>(url)
		);

		// const result = from<Array<SystemModel>>(
		// 	objectObservable
		// ).pipe(map((src: Array<ISystemModel>, index: number) => {
		// 	const dst = new Array<SystemModel>();
		// 	src.forEach(element => {
		// 		const stronglyTyped = new SystemModel(element);
		// 		dst.push(stronglyTyped);
		// 	});
		// 	return dst;
		// }));
		// return result;
	}

	// Get SalesEntity Board Target Lists and assign it to the service property.
	// public PopulateSalesEntityBoardTargets() {
	//     this.GetSalesEntityBoardTargets().subscribe(resp => {
	//         console.log(resp);
	//         this.boardTargets = resp.BoardOk;
	//     });
	// }

	public GetSalesEntityBoardTargets(filter: string = null) {
		let url = this.controller + 'GetSalesEntityBoardTargets';
		if (filter) {
			url = url + "?filter=" + filter;
			return this.http.get<ISalesEntityBoardTargets>(url);
		} else {
			return this.cacheService.get(
				url,
				this.http.get<ISalesEntityBoardTargets>(url)
			);
		}

	}
	/**
	 * 
	 * @param filter filter for 
	 */
	public GetApplicationSalesEntities(filter: string = null) {
		let url = this.controller + 'GetSalesEntitiesForApplications';
		console.log("Getting sales entities for apps: ", url);
		if (filter) {
			url = url + "?filter=" + filter;
			return this.http.get<EnhApplicationAgentsResponse>(url);
		} else {
			//when there's no filter we can cache, for some reason the ui doesn't trigger properly when it's cached though (todo)
			return this.cacheService.get(
				url,
				this.http.get<EnhApplicationAgentsResponse>(url)
			);
		}

	}

	public GetDashboardMetrics() {
		const url = this.controller + 'metrics/';
		return this.cacheService.get(url, this.http.get<IMerchantsCount>(url));
	}

	// Get Contracts By Sales Entity TODO
	public GetContractsBySalesEntity(
		SalesEntityID: number
	): Observable<ContractResult> {
		const url =
			this.controller + 'GetContractsList/' + SalesEntityID.toString();
		return this.http.get<ContractResult>(url);
	}

	//This method is only for getting contracts for the create application page
	public GetNewAppContractsBySalesEntity(
		SalesEntityID: number
	): Observable<ContractResult> {
		const url =
			this.controller + 'GetAppContractsList/' + SalesEntityID.toString();
		return this.http.get<ContractResult>(url);
	}

	/**
	 * Deletes a contract by ID from a salesEntityID
	 * @param entityID Sales Entity ID to delete contract from
	 * @param contractID The Contract being deleted
	 */
	public DeleteContract(contractID: number) {
		const url = this.controller + "DeleteContract";
		let parms = new HttpParams().set('ContractID', contractID.toString());
		return this.http.delete(url, { params: parms });
	}
	/**
	 * Updates a contract for a sales entity
	 * @param contract The contract to Update (must contain SE_ID and C_ID)
	 */
	public UpdateContract(contract: Contract) {
		if (!contract.SalesEntityID) { throw "SalesEntityID must be defined"; }
		if (!contract.ContractID) { throw "ContractID must be defined"; }
		const url = this.controller + "UpdateContract";
		return this.http.post(url, contract);
	}

	/**
	 * 
	 * @param contract New contract to insert (must contain SE_ID)
	 */
	public InsertContract(contract: Contract) {
		if (!contract.SalesEntityID) { throw "SalesEntityID must be defined"; }
		const url = this.controller + "InsertContract";
		return this.http.post(url, contract);
	}


	public getInstitutions(sid: number): Observable<Array<Institution>> {
		const url = this.controller + 'GetInstitutions';
		console.log("SID:", sid);
		const parms = new HttpParams().set('sid', sid.toString());
		return this.cacheService.get(
			url + parms,
			this.http.get<Array<IInstitution>>(url, {
				params: parms
			})
		);

		// const result = from<Array<Institution>>(
		// 	objectObservable
		// ).pipe(map((src: Array<IInstitution>, index: number) => {
		// 	const dst = new Array<Institution>();
		// 	src.forEach(element => {
		// 		const stronglyTyped = new Institution(element);
		// 		dst.push(stronglyTyped);
		// 	});
		// 	return dst;
		// }));
		// return result;
	}

	public getAssociations(
		sid: number,
		iid: number
	): Observable<Array<Association>> {
		const url = this.controller + 'GetAssociations';
		console.log("SID, IID:", sid, iid);
		const parms = new HttpParams()
			.set('sid', sid.toString())
			.append('iid', iid.toString());
		return this.cacheService.get(
			url + parms,
			this.http.get(url, { params: parms })
		);

		// const result = from<Array<Association>>(
		// 	objectObservable
		// ).pipe(map((src: Array<IAssociation>, index: number) => {
		// 	const dst = new Array<Association>();
		// 	src.forEach(element => {
		// 		const stronglyTyped = new Association(element);
		// 		dst.push(stronglyTyped);
		// 	});
		// 	return dst;
		// }));
		// return result;
	}

	public getSalesReps(
		sid: number,
		iid: number,
		aid: number
	): Observable<Array<SalesRep>> {
		const url = this.controller + 'GetSalesReps';
		const parms = new HttpParams()
			.set('sid', sid.toString())
			.append('iid', iid.toString())
			.append('aid', aid.toString());
		return this.cacheService.get(
			url + parms,
			this.http.get(url, { params: parms })
		);

		// const result = from<Array<SalesRep>>(objectObservable).pipe(map(
		// 	(src: Array<ISalesRep>, index: number) => {
		// 		const dst = new Array<SalesRep>();
		// 		src.forEach(element => {
		// 			const stronglyTyped = new SalesRep(element);
		// 			dst.push(stronglyTyped);
		// 		});
		// 		return dst;
		// 	}
		// ));
		// return result;
	}

	public getChains(
		sid: number,
		iid: number,
		aid: number,
		srid: number
	): Observable<Array<Chain>> {
		const url = this.controller + 'GetChains';
		console.log(url, sid, iid, aid, srid);
		const parms = new HttpParams()
			.set('sid', sid.toString())
			.append('iid', iid.toString())
			.append('aid', aid.toString())
			.append('srid', srid.toString());
		console.log(parms);
		return this.cacheService.get(
			url + parms,
			this.http.get(url, { params: parms })
		);
		// console.log(objectObservable);
		// const result = from<Array<Chain>>(objectObservable).pipe(map(
		// 	(src: Array<IChain>, index: number) => {
		// 		const dst = new Array<Chain>();
		// 		src.forEach(element => {
		// 			const stronglyTyped = new Chain(element);
		// 			dst.push(stronglyTyped);
		// 		});
		// 		console.log(dst);
		// 		return dst;
		// 	}
		// ));
		// console.log(result);
		// return result;
	}



	public getAuditHistory(entityID: number) {
		const url = this.controller + 'GetAuditHistory';
		const parms = new HttpParams().set('entityID', entityID.toString());
		const observable = this.cacheService.get(
			url + parms,
			this.http.get<Array<SalesEntityAddress>>(url, {
				params: parms
			})
		);
		return observable;
	}

	public getAddresses(entityID: number, refreshCache: boolean = false) {
		const url = this.controller + 'GetAddresses';
		const parms = new HttpParams().set('entityID', entityID.toString());
		let observable;
		if (refreshCache) {
			return this.http.get<Array<SalesEntityAddress>>(url, {
				params: parms
			});
		} else {
			observable = this.cacheService.get(
				url + parms,
				this.http.get<Array<SalesEntityAddress>>(url, {
					params: parms
				})
			);
		}
		return observable;
	}

	/**
	 * Gets contacts by sales entity ID
	 * @param entityID SE_ID for whom you want contacts for
	 * @param refreshCache Optionally refreshes the cache call for contacts
	 */
	public getContacts(entityID: number, refreshCache: boolean = false) {
		const url = this.controller + 'GetContacts';
		const parms = new HttpParams().set('entityID', entityID.toString());
		let observable;
		if (refreshCache) {
			return this.http.get<Array<SalesEntityContact>>(url, {
				params: parms
			});
		} else {
			observable = this.cacheService.get(
				url + parms,
				this.http.get<Array<SalesEntityContact>>(url, {
					params: parms
				})
			);
		}
		return observable;
	}

	/**
	 * Deletes a contact by ID from a salesEntityID
	 * @param entityID Sales Entity ID to delete contact from
	 * @param contactID The Contact being deleted
	 */
	public DeleteContact(contactID: number) {
		const url = this.controller + "DeleteContact";
		let parms = new HttpParams().set('ContactID', contactID.toString());
		return this.http.delete(url, { params: parms });
	}
	/**
	 * Updates a contact for a sales entity
	 * @param contact The contact to Update (must contain SE_ID and C_ID)
	 */
	public UpdateContact(contact: SalesEntityContact) {
		if (!contact.SalesEntityID) { throw "SalesEntityID must be defined"; }
		if (!contact.ContactID) { throw "ContactID must be defined"; }
		const url = this.controller + "UpdateContact";
		return this.http.post(url, contact);
	}

	/**
	 * 
	 * @param contact New contact to insert (must contain SE_ID)
	 */
	public InsertContact(contact: SalesEntityContact) {
		if (!contact.SalesEntityID) { throw "SalesEntityID must be defined"; }
		const url = this.controller + "InsertContact";
		return this.http.post(url, contact);
	}

	//ADDRESSES

	/**
	 * Deletes a contact by ID from a salesEntityID
	 * @param addressID The Contact being deleted
	 */
	public DeleteAddress(addressID: number) {
		const url = this.controller + "DeleteAddress";
		let parms = new HttpParams().set('AddressID', addressID.toString());
		return this.http.delete(url, { params: parms });
	}
	/**
	 * Updates a contact for a sales entity
	 * @param address The address to Update (must contain SE_ID and A_ID)
	 */
	public UpdateAddress(address: SalesEntityAddress) {
		if (!address.SalesEntityID) { throw "SalesEntityID must be defined"; }
		if (!address.AddressID) { throw "AddressID must be defined"; }
		const url = this.controller + "UpdateAddress";
		return this.http.post(url, address);
	}
	/**
	 * 
	 * @param address New address to insert (must contain SE_ID)
	 */
	public InsertAddress(address: SalesEntityAddress) {
		if (!address.SalesEntityID) { throw "SalesEntityID must be defined"; }
		const url = this.controller + "InsertAddress";
		return this.http.post(url, address);
	}

	/**
	 * Gets a list of all possible channels (for a dropdown)
	 */
	public GetChannels() {
		const url = this.controller + 'GetChannels/';
		return this.cacheService.get(
			url,
			this.http.get<Array<Channel>>(url)
		);
	}

	public GetAPs() {
		const url = this.controller + 'GetAPs/';
		return this.cacheService.get(
			url,
			this.http.get<Array<AlliancePartnerESP>>(url)
		);
	}

	/**
	 * Gets a list of all possible types (for a dropdown)
	 */
	public GetTypes() {
		const url = this.controller + 'GetTypes/';
		return this.cacheService.get(
			url,
			this.http.get<Array<Channel>>(url)
		);
	}


	public saveSalesEntity(model: SalesEntityModel) {
		const url = this.controller + "SaveSalesEntity/";
		let body = JSON.stringify(model);
		// let parms = new HttpParams().set('id', salesEntityID.toString());
		// parms = parms.append('label', hierarchyLabel);
		//console.log("Making default:", url, parms, salesEntityID, hierarchyLabel);
		return this.http.post(url, body, {
			headers: new HttpHeaders().set(
				'Content-Type',
				'application/json')
		}
		);
	}
	/**
	 * Gets list of hierarchies
	 * @returns Observable of SalesEntityBoardingHierarchy[]
	 */
	public GetBoardingHierarchies(salesEntityID: number) {
		const url = this.controller + 'GetBoardingHierarchies/' + salesEntityID.toString();
		return this.http.get<Array<SalesEntityBoardingHierarchy>>(url);
	}

	/**
	 * Deletes the hierarchy by API call
	 * @param hierarchyID the ID to delete
	 * @param hierarchyLabel the label to delete
	 */
	public DeleteBoardingHierarchy(hierarchyID: number, hierarchyLabel: string) {
		const url = this.controller + "DeleteBoardingHierarchy";
		let parms = new HttpParams().set('id', hierarchyID.toString());
		parms = parms.append('label', hierarchyLabel);
		return this.http.delete(url, { params: parms });
	}
	/**
	 * Sets the hierarchy to default by API call
	 * @param hierarchyID the ID to make default
	 * @param hierarchyLabel the label to make default
	 */
	public MakeDefaultBoardingHierarchy(salesEntityID: number, hierarchyLabel: string) {
		const url = this.controller + "MakeDefaultBoardingHierarchy/" + salesEntityID.toString() + "/" + encodeURI(hierarchyLabel);
		// let parms = new HttpParams().set('id', salesEntityID.toString());
		// parms = parms.append('label', hierarchyLabel);
		//console.log("Making default:", url, parms, salesEntityID, hierarchyLabel);
		return this.http.post(url, {});
	}
	/**
	 * Inserts a new boarding hierarchy 
	 * @param toInsert The new hierarchy model to insert
	 */
	public AddBoardingHierarchy(toInsert: SalesEntityBoardingHierarchyNew) {
		const url = this.controller + 'InsertBoardingHierarchy';
		return this.http.post<SalesEntityBoardingHierarchyNew>(url, toInsert);
	}

	public getContracts(
		entityID: number,
		parentContractID: number,
		pageNumber: number,
		maxRows: number,
		refreshCache: boolean = false
	) {
		const url = this.controller + 'GetContracts';
		const parms = new HttpParams()
			.set('entityID', entityID.toString())
			.append('parentContractID', parentContractID.toString())
			.append('startPage', pageNumber.toString())
			.append('maxRows', maxRows.toString());
		let observable;
		if (refreshCache) {
			observable = this.http.get<ContractResult>(url, {
				params: parms
			});
		} else {
			observable = this.cacheService.get(
				url + parms,
				this.http.get<ContractResult>(url, {
					params: parms
				})
			);
		}

		return observable;
	}

	public getContractsFromSeat(entityID: number) {
		const url = this.controller + `GetContractsListFromSeat/${entityID}`;
		return this.http.get<any>(url, {});
	}

	/**
	 * Gets a list of comp plans (paged using inquiry)
	 * @param inq Comp Plan Inquiry to post
	 * @param refreshCache N/A this is not currently cached
	 */
	public getCompPlanList(
		inq: CompPlanListInq,
		refreshCache: boolean = false
	): Promise<Array<CompPlan>> {
		const url = this.controller + 'GetCompPlanList';
		return this.http.post<Array<CompPlan>>(url, inq).toPromise<Array<CompPlan>>();
	}

	/**
	 * Get comp plan by ID
	 * @param id comp plan ID
	 * @param refreshCache N/A this is not implemented (will refresh cache)
	 */
	public getCompPlan(
		id: number,
		refreshCache: boolean = false
	): Promise<CompPlan> {
		const url = this.controller + 'GetCompPlan/' + id.toString();
		return this.http.get<CompPlan>(url).toPromise<CompPlan>();
	}


	/**
	 * Inserts a new comp plan
	 * @param cplan Comp plan to insert
	 */
	public insertCompPlan(cplan: CompPlan) {
		const url = this.controller + 'InsertCompPlan';
		return this.http.post<number>(url, cplan);
	}

	/**
	 * Updates a comp plan to the values passed (anything null is ignored)
	 * @param cplan Comp Plan to Update
	 */
	public updateCompPlan(cplan: CompPlan) {
		const url = this.controller + 'UpdateCompPlan';
		return this.http.post(url, cplan);
	}

	/**
	 * Deletes a comp plan through change approval by ID
	 * @param compPlanID Comp plan ID to delete
	 */
	public deleteCompPlan(compPlanID: number) {
		const url = this.controller + "DeleteCompPlan";
		let parms = new HttpParams().set('CompPlanID', compPlanID.toString());
		return this.http.delete(url, { params: parms });
	}


	/**
	 * Gets a list of tiers by compplan ID
	 * @param cid CompPlanID to get tiers for
	 * @param refreshCache 
	 */
	public getTiersList(
		cid: number,
		refreshCache: boolean = false
	): Promise<Array<CompPlanTier>> {
		const url = this.controller + 'GetTiersList/' + cid.toString();
		return this.http.get<Array<CompPlanTier>>(url).toPromise<Array<CompPlanTier>>();
	}

	/**
	 * Inserts a new comp plan tier
	 * @param tier Tier to insert
	 */
	public insertTier(tier: CompPlanTier) {
		const url = this.controller + 'InsertTier';
		return this.http.post<number>(url, tier);
	}

	/**
	 * Deletes tier by ID
	 * @param tid TierID to delete
	 */
	public deleteTier(tid: number) {
		const url = this.controller + "DeleteTier";
		let parms = new HttpParams().set('TierID', tid.toString());
		return this.http.delete(url, { params: parms });
	}

	/**
	 * Gets relationship types for this SEID
	 * @param seid SalesEntityID to get types for
	 * @param refreshCache Not implemented (will refresh cache)
	 */
	public getRelationshipTypesList(
		seid: number,
		refreshCache: boolean = false
	): Promise<Array<RelationshipTypeEnforcedDTO>> {
		const url = this.controller + 'GetRelationshipTypesList/' + seid.toString();
		return this.http.get<Array<RelationshipTypeEnforcedDTO>>(url).toPromise<Array<RelationshipTypeEnforcedDTO>>();
	}

	/**
	 * Inserts a new relationship type via POST
	 * @param type RelationshipType to insert 
	 */
	public insertRelationshipType(type: RelationshipType) {
		const url = this.controller + 'InsertRelationshipType';
		return this.http.post(url, type);
	}
	/**
	 * Updates a relationship type via POST
	 * @param type RelationshipType to update
	 */
	public updateRelationshipType(type: RelationshipType) {
		const url = this.controller + 'UpdateRelationshipType';
		return this.http.post(url, type);
	}

	/**
	 * Deletes a RelationshipType by ID
	 * @param typeID TypeID to delete
	 */
	public deleteRelationshipType(typeID: number) {
		const url = this.controller + "DeleteRelationshipType";
		let parms = new HttpParams().set('RelationshipTypeID', typeID.toString());
		return this.http.delete(url, { params: parms });
	}

	/**
	 * 
	 * @param seid SE_ID (OWNER) to get pricing list for
	 * @param refreshCache Not implemented (will refresh cache)
	 */
	public getPricingList(
		seid: number,
		refreshCache: boolean = false
	): Promise<Array<E_PriceLists>> {
		const url = this.controller + 'GetPricingList/' + seid.toString();
		return this.http.get<Array<E_PriceLists>>(url).toPromise<Array<E_PriceLists>>();
	}

	/**
	 * 
	 * @param seid SE_ID (OWNER) to get types for
	 * @param refreshCache Not implemented (will refresh the cache)
	 */
	public getTieringTypesList(
		seid: number,
		refreshCache: boolean = false
	): Promise<Array<KeyValuePair<string, number>>> {
		const url = this.controller + 'GetTieringTypesList/' + seid.toString();
		return this.http.get<Array<KeyValuePair<string, number>>>(url).toPromise<Array<KeyValuePair<string, number>>>();
	}
	/**
	 * Gets commissions date default for a SE ID
	 * @param seid SE_ID to fetch commissions date for
	 * @param refreshCache TODO: currently unused, would refresh any caching
	 */
	public getCommissionsDefaultDate(
		seid: number,
		refreshCache: boolean = false
	): Promise<Date> {
		const url = this.controller + 'GetCommisionDateBySalesEntityID/' + seid.toString();
		return this.cacheService.get(
			url,
			this.http.get<Date>(url)
		).toPromise();
	}


	/**
	 * I thought we would use the global edit button for more than 1 page.
	 * We didn't.
	 * @returns true if your route is on the setup details page of sales entities.
	 */
	public RouteIsEditable(): boolean {
		//console.log(this.router.url);
		if (this.router.url.toUpperCase().indexOf('/SALES-ENTITY/DETAIL/SETUP') >= 0) {
			return true;
		}
		// else if (this.router.url.toUpperCase().indexOf('/SALES-ENTITY/DETAIL/CONTACT') >= 0) {
		// 	return true;
		// }
		// else if (this.router.url.toUpperCase().indexOf('/SALES-ENTITY/DETAIL/ADDRESSES') >= 0) {
		// 	return true;
		// }

		return false;
	}

	/**
	 * Returns dropdown data for a state dropdown.
	 * @returns Array {name, abbreviation} for all US states (sorted by name)
	 */
	public StateDropdownData() {
		return this.stateData().sort((a, b) => (a.abbreviation > b.abbreviation) ? 1 : ((b.abbreviation > a.abbreviation) ? -1 : 0));
	}

	/**
	 * Returns dropdown data for a state dropdown.
	 * @returns Array {name, abbreviation} for all US states.
	 */
	private stateData() {
		return [
			{
				"name": "Alabama",
				"abbreviation": "AL"
			},
			{
				"name": "Alaska",
				"abbreviation": "AK"
			},
			//{
			//    "name": "American Samoa",
			//    "abbreviation": "AS"
			//},
			{
				"name": "Arizona",
				"abbreviation": "AZ"
			},
			{
				"name": "Arkansas",
				"abbreviation": "AR"
			},
			{
				"name": "California",
				"abbreviation": "CA"
			},
			{
				"name": "Colorado",
				"abbreviation": "CO"
			},
			{
				"name": "Connecticut",
				"abbreviation": "CT"
			},
			{
				"name": "Delaware",
				"abbreviation": "DE"
			},
			{
				"name": "District Of Columbia",
				"abbreviation": "DC"
			},
			//{
			//    "name": "Federated States Of Micronesia",
			//    "abbreviation": "FM"
			//},
			{
				"name": "Florida",
				"abbreviation": "FL"
			},
			{
				"name": "Georgia",
				"abbreviation": "GA"
			},
			//{
			//    "name": "Guam",
			//    "abbreviation": "GU"
			//},
			{
				"name": "Hawaii",
				"abbreviation": "HI"
			},
			{
				"name": "Idaho",
				"abbreviation": "ID"
			},
			{
				"name": "Illinois",
				"abbreviation": "IL"
			},
			{
				"name": "Indiana",
				"abbreviation": "IN"
			},
			{
				"name": "Iowa",
				"abbreviation": "IA"
			},
			{
				"name": "Kansas",
				"abbreviation": "KS"
			},
			{
				"name": "Kentucky",
				"abbreviation": "KY"
			},
			{
				"name": "Louisiana",
				"abbreviation": "LA"
			},
			{
				"name": "Maine",
				"abbreviation": "ME"
			},
			//{
			//    "name": "Marshall Islands",
			//    "abbreviation": "MH"
			//},
			{
				"name": "Maryland",
				"abbreviation": "MD"
			},
			{
				"name": "Massachusetts",
				"abbreviation": "MA"
			},
			{
				"name": "Michigan",
				"abbreviation": "MI"
			},
			{
				"name": "Minnesota",
				"abbreviation": "MN"
			},
			{
				"name": "Mississippi",
				"abbreviation": "MS"
			},
			{
				"name": "Missouri",
				"abbreviation": "MO"
			},
			{
				"name": "Montana",
				"abbreviation": "MT"
			},
			{
				"name": "Nebraska",
				"abbreviation": "NE"
			},
			{
				"name": "Nevada",
				"abbreviation": "NV"
			},
			{
				"name": "New Hampshire",
				"abbreviation": "NH"
			},
			{
				"name": "New Jersey",
				"abbreviation": "NJ"
			},
			{
				"name": "New Mexico",
				"abbreviation": "NM"
			},
			{
				"name": "New York",
				"abbreviation": "NY"
			},
			{
				"name": "North Carolina",
				"abbreviation": "NC"
			},
			{
				"name": "North Dakota",
				"abbreviation": "ND"
			},
			//{
			//    "name": "Northern Mariana Islands",
			//    "abbreviation": "MP"
			//},
			{
				"name": "Ohio",
				"abbreviation": "OH"
			},
			{
				"name": "Oklahoma",
				"abbreviation": "OK"
			},
			{
				"name": "Oregon",
				"abbreviation": "OR"
			},
			//{
			//    "name": "Palau",
			//    "abbreviation": "PW"
			//},
			{
				"name": "Pennsylvania",
				"abbreviation": "PA"
			},
			{
				"name": "Puerto Rico",
				"abbreviation": "PR"
			},
			{
				"name": "Rhode Island",
				"abbreviation": "RI"
			},
			{
				"name": "South Carolina",
				"abbreviation": "SC"
			},
			{
				"name": "South Dakota",
				"abbreviation": "SD"
			},
			{
				"name": "Tennessee",
				"abbreviation": "TN"
			},
			{
				"name": "Texas",
				"abbreviation": "TX"
			},
			{
				"name": "Utah",
				"abbreviation": "UT"
			},
			{
				"name": "Vermont",
				"abbreviation": "VT"
			},
			//{
			//    "name": "Virgin Islands",
			//    "abbreviation": "VI"
			//},
			{
				"name": "Virginia",
				"abbreviation": "VA"
			},
			{
				"name": "Washington",
				"abbreviation": "WA"
			},
			{
				"name": "West Virginia",
				"abbreviation": "WV"
			},
			{
				"name": "Wisconsin",
				"abbreviation": "WI"
			},
			{
				"name": "Wyoming",
				"abbreviation": "WY"
			}
		];
	}

} // class
